
import { Options, Vue } from "vue-class-component";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import discordIcon from "./images/discord-circle-v2.svg";

@Options({ components: { SvgIcon } })
export default class DiscordButton extends Vue {
  protected communityUrl = "https://discord.gg/Z6pRrqE9sW";
  protected discordIcon = discordIcon;
}
